import { render, staticRenderFns } from "./newstOrder.vue?vue&type=template&id=afda098a&scoped=true&"
import script from "./newstOrder.vue?vue&type=script&lang=js&"
export * from "./newstOrder.vue?vue&type=script&lang=js&"
import style0 from "./newstOrder.vue?vue&type=style&index=0&id=afda098a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afda098a",
  null
  
)

export default component.exports